import { render, staticRenderFns } from "./CmgPasswordResetPage.vue?vue&type=template&id=4fb3a39a&scoped=true&lang=pug"
import script from "./cmg-password-reset-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-password-reset-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPasswordResetPage.vue?vue&type=style&index=0&id=4fb3a39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3a39a",
  null
  
)

export default component.exports